import type { ChatFileDownload } from '../types';

const STORAGE_KEY = 'mcp-widget:file-downloads';

interface StoredDownload {
  conversationId: string;
  msgIndex: number;
  file: ChatFileDownload;
  expiresAt: string;
}

function readAll(): StoredDownload[] {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]');
  } catch {
    return [];
  }
}

function writeAll(entries: StoredDownload[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
  } catch { /* ignore quota errors */ }
}

export function saveFileDownload(
  conversationId: string,
  msgIndex: number,
  file: ChatFileDownload,
  expiresAt: string,
): void {
  const all = readAll().filter(e => !(e.conversationId === conversationId && e.file.url === file.url));
  all.push({ conversationId, msgIndex, file, expiresAt });
  // Prune expired entries
  const now = Date.now();
  writeAll(all.filter(e => new Date(e.expiresAt).getTime() > now));
}

/** Returns non-expired downloads for a conversation, grouped by message index. */
export function loadFileDownloads(conversationId: string): Map<number, ChatFileDownload[]> {
  const now = Date.now();
  const map = new Map<number, ChatFileDownload[]>();
  for (const entry of readAll()) {
    if (entry.conversationId !== conversationId) continue;
    if (new Date(entry.expiresAt).getTime() <= now) continue;
    const bucket = map.get(entry.msgIndex) ?? [];
    bucket.push(entry.file);
    map.set(entry.msgIndex, bucket);
  }
  return map;
}
